import ZellePage from "components/pages/ZellePage";

export default function CaptureQuickTourZelle(props) {
    return <ZellePage />
}